import { COLORS } from '@/app/constants';
import { VITE_APP_API_MEDIA_URL } from '@/app/constants/APIKEYS';
import { Modal } from 'antd';
import styled from 'styled-components';

export const CustomModal = styled(Modal)<{ systemImage: string }>`
  .ant-modal-content {
    height: 672px;
    width: 480px;
    border-radius: 6px;
    box-shadow: none;
    background-color: ${({ theme }) => theme.COLORS.PrimaryBg};
    background-image: ${({ systemImage }) =>
      systemImage ? `url(${VITE_APP_API_MEDIA_URL}/${systemImage})` : 'none'};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    padding: 0;
    font-family: 'Pretendard' !important;
  }

  .ant-modal-body {
    height: 100%;
  }
`;

export const ModalDesContainer = styled.div`
  position: relative;
  margin-top: 42px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  z-index: 2;
`;

export const ModalDesName = styled.div<{ isDarkmode: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ isDarkmode }) => (isDarkmode ? `#9897A0` : `#757575`)};
`;

export const ModalDesValue = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
`;

export const QRContainer = styled.div`
  width: 92px;
  height: 92px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${COLORS.white};
  border-radius: 6px;
`;

export const ReferralCode = styled.div`
  font-size: 18px;
  font-weight: 500;
`;

export const DownloadBtn = styled.button`
  width: 190px;
  height: 100%;
  background-color: ${COLORS.primary};
  border-radius: 4px;

  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.white};
  font-family: 'pretendard' !important;
`;

export const CancelBtn = styled.button`
  width: 110px;
  border: 1px solid ${({ theme }) => theme.COLORS.tableBtn};
  border-radius: 4px;
  background-color: transparent;
  color: ${({ theme }) => theme.COLORS.textw};
  font-family: 'pretendard' !important;
`;

export const BackSvg = styled.svg`
  width: 424.8px;
  height: 356.08px;
`;
